//------------------------------------------------------------------------------------------------------------------------------
// ค่าใช้จ่ายปีแรกที่เกษียณ ปรับด้วยเงินเฟ้อ
//-- rate = สมมุติฐานอัตราเงินเฟ้อระยะยาว => ex. 2% = 2/100 = 0.02
//-- nper = ระยะเวลาก่อนเกษียณ => ex. 25 ปี
//-- pv = ค่าใช้จ่ายหลังเกษียณที่ต้องการ *ต่อปี* => ex. 180,000 บาท/ปี
export const fv = (rate: number, nper: number, pv: number) => {
    let result = 0

    result = pv * Math.pow(1 + rate, nper)
    return result
}
// let futureValue = fv(0.02, 25, 180000)
// console.log('ค่าใช้จ่ายปีแรกที่เกษียณ ปรับด้วยเงินเฟ้อ:', futureValue) // 295309.079...

//------------------------------------------------------------------------------------------------------------------------------
// อัตราผลตอบแทนหลังเกษียณ-ปรับด้วยเงินเฟ้อ
//-- rate = สมมุติฐานอัตราเงินเฟ้อระยะยาว => ex. 2% = 2/100 = 0.02
//-- yield = อัตราผลตอบแทนหลังเกษียณ => ex. 3% = 3/100 = 0.03
export const ror = (rate: number, _yield: number) => {
    let result = 0

    result = (1 + _yield) / (1 + rate) - 1
    return result
}
// let returnofRM = ror(0.02, 0.03)
// console.log('อัตราผลตอบแทนหลังเกษียณ-ปรับด้วยเงินเฟ้อ:', returnofRM) // 0.0098...

//------------------------------------------------------------------------------------------------------------------------------
// เงินทุนเพื่อการเกษียณอายุทั้งหมดที่ต้องมี
//-- rate = อัตราผลตอบแทนหลังเกษียณ-ปรับด้วยเงินเฟ้อ => จากฟังก์์ชัน ror
//-- nper = ระยะเวลาใช้ชีวิตหลังเกษียณ => ex. 30 ปี
//-- fv = ค่าใช้จ่ายปีแรกที่เกษียณ ปรับด้วยเงินเฟ้อ => จากฟังก์์ชัน fv
export const pv = (
    rate: number,
    nper: number,
    pmt: number = 0,
    fv?: number,
    type?: number
) => {
    let sum = 0

    for (var i = 0; i < nper; i++) {
        sum = sum + pmt / Math.pow(1 + rate, i)
    }
    return sum
}
// let presentValue = pv(returnofRM, 30, futureValue)
// console.log('เงินทุนเพื่อการเกษียณ:', presentValue) // 7718059.32...

// ประมาณการเงินทุนเพื่อการเกษียณ
//-- rate = อัตราผลตอบแทนคาดหวังก่อนเกษียณ => ex. 2% = 2/100 = 0.02
//-- nper = ระยะเวลาก่อนเกษียณ => ex. 25 ปี
//-- pv = เงินกองทุนสำรองเลี้ยงชีพ / กบข + สินทรัพย์ลงทุนเพื่อบรรลุเป้าหมายเกษียณ

export const est = (rate: number, nper: number, pv: number) => {
    let result = 0
    result = pv * Math.pow(1 + rate, nper)
    return result
}
// let estimateFunds = est(0.02, 25, ps(35) + 1000000)
// console.log('ประมาณการเงินทุนเพื่อการเกษียณ:', estimateFunds) // 1888791.865...

//------------------------------------------------------------------------------------------------------------------------------
// ส่วนขาดของเงินทุนเพื่อการเกษียณที่ต้องการเพิ่ม
//-- pv = เงินทุนเพื่อการเกษียณอายุทั้งหมดที่ต้องมี
//-- est = ประมาณการเงินทุนเพื่อการเกษียณ
export const def = (pv: number, est: number) => {
    if (pv > est) {
        return pv - est
    } else {
        return 0 //เพียงพอ
    }
}
// let deficit = def(presentValue, estimateFunds)
// console.log('ส่วนขาดของเงินทุนเพื่อการเกษียณที่ต้องการเพิ่ม:', deficit) // 5829267.457...

//------------------------------------------------------------------------------------------------------------------------------
// ลงทุนเพิ่ม กรณีคาดหวังผลตอบแทน %
//-- rate = อัตราผลตอบแทนที่คาดหวัง => ex. 2% = 2/100 = 0.02
//-- nper = ระยะเวลาก่อนเกษียณ => ex. 25 ปี
//-- pv = ส่วนขาดของเงินทุนเพื่อการเกษียณที่ต้องการเพิ่ม => ex. 5829267
export const pmt = (rate: number, nper: number, pv: number) => {
    let result = 0
    if (pv === 0) {
        return 0
    } else {
        result = (pv * rate) / (Math.pow(1 + rate, nper) - 1) / 12
        return result
    }
}
// console.log(`ลงทุนเพิ่ม กรณีคาดหวังผลตอบแทน 2.00%:`, pmt(0.02, 25, deficit)) // 15166.023...
// console.log(`ลงทุนเพิ่ม กรณีคาดหวังผลตอบแทน 4.00%:`, pmt(0.04, 25, deficit)) // 11664.346...
// console.log(`ลงทุนเพิ่ม กรณีคาดหวังผลตอบแทน 6.00%:`, pmt(0.06, 25, deficit)) // 8854.034...
// console.log(`ลงทุนเพิ่ม กรณีคาดหวังผลตอบแทน 8.00%:`, pmt(0.08, 25, deficit)) // 6644.771...
